// extracted by mini-css-extract-plugin
export var content = "InfoGrid-module--content--MwkNF";
export var image = "InfoGrid-module--image--kWFF0";